module.exports = __webpack_public_path__ + "img/tips10.5d3fb20a.png";